/**
 * Hero Full Bleed Component
 * Handles video play/pause controls and accessibility
 */

document.addEventListener('DOMContentLoaded', function() {
  const videoControls = document.querySelectorAll('.js-hero__media-controls');

  function updateButtonState(button, isPaused) {
    const playIcon = button.querySelector('.js-play-icon');
    const pauseIcon = button.querySelector('.js-pause-icon');

    if (isPaused) {
      if (playIcon) playIcon.classList.remove('hidden');
      if (pauseIcon) pauseIcon.classList.add('hidden');
    } else {
      if (playIcon) playIcon.classList.add('hidden');
      if (pauseIcon) pauseIcon.classList.remove('hidden');
    }
  }

  videoControls.forEach(button => {
    const heroContainer = button.closest('.hero');
    if (!heroContainer) return;

    const videos = heroContainer.querySelectorAll('video');
    if (videos.length > 0) {
      updateButtonState(button, videos[0].paused);
    }

    button.addEventListener('click', function() {
      videos.forEach(video => {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

      setTimeout(() => {
        if (videos.length > 0) {
          updateButtonState(button, videos[0].paused);
        }
      }, 0);
    });

    videos.forEach(video => {
      video.addEventListener('play', () => {
        updateButtonState(button, false);
      });
      video.addEventListener('pause', () => {
        updateButtonState(button, true);
      });
    });
  });
});